module.exports = __webpack_public_path__ + "static/media/dryerIcon.ee7e7573.svg";